// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"60eae34b","239":"540428c2","455":"c492fe37"}[chunkId] + ".chunk.js";
};